import { useContext } from 'react';
import ConfigContext from '../contexts/ConfigContext';

function useFacebookApi() {
  const { facebookAppId } = useContext(ConfigContext);

  const loadFacebookSDK = () => {
    if (!facebookAppId) {
      return Promise.reject(new Error('Facebook App ID not set.'));
    }

    if (window.FB) {
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: facebookAppId,
          xfbml: true,
          version: 'v26.0'
        });
        resolve();
      };
    });
  };

  return { loadFacebookSDK };
}

export default useFacebookApi;
